import axios from 'axios';
import ExtensionChecker from './extensionChecker';
import { SessionStorageKeys } from './sessionStorageKeys.const';

export default class UserAuth {
    constructor() {
        this.requestCounter = 0;
        this.timeoutId = null;
        this.waitTimeout = 0;
    }

    static getUrl = url => process.env.baseHref + url;

    static getCompanySettings() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/online/v1/settings')
        });
    }

    static getIdPData(username) {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/auth/v2/login/options'),
            params: { username }
        })
    }

    static login(authUrl, authData, deviceInfo) {
        let config = {
            method: 'POST',
            url: this.getUrl(authUrl),
            data: authData,
            headers: {}
        };

        if (deviceInfo != null) {
            config.headers['X-Device-Name'] = encodeURIComponent(deviceInfo.name);
            config.headers['X-Device-Id'] = encodeURIComponent(deviceInfo.id);
        }

        const extensionVersion = ExtensionChecker.getVersion();
        if(extensionVersion !== 'not installed') {
            config.headers['X-Extension-Version'] = extensionVersion;
        }

        return axios(config);
    }

    static logout() {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/auth/v2/logout')
        });
    }

    static clearAuthSessionStorage() {
        sessionStorage.removeItem(SessionStorageKeys.companySettings);
        sessionStorage.removeItem(SessionStorageKeys.helpInfo);
        sessionStorage.removeItem(SessionStorageKeys.featureSettings);
        sessionStorage.removeItem(SessionStorageKeys.onboardingUsername);
    }

    checkRequestCounter(resolve, maxWaitTimeout) {
        if (this.requestCounter > 0 && this.waitTimeout <= maxWaitTimeout) {
            this.waitTimeout += 1000;
            this.timeoutId = setTimeout(() => {
                this.checkRequestCounter(resolve, maxWaitTimeout);
            }, 1000);
            return;
        } else {
            /* istanbul ignore else */
            if (!isNaN(this.timeoutId)) {
                clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            resolve();
        }
    }

    static getAutoLoginDataV2(url) {
        return axios({
            method: 'GET',
            url: this.getUrl(url)
        });
    }

    startAutoLoginFor(url, token) {
        this.requestCounter++;
        axios({
            method: 'GET',
            url: process.env.baseHref + url + '/auth/v2/autologin'+'?token=' + token + '&timestamp=' + Math.floor(Date.now() / 1000),
            withCredentials: true
        }).then(() => {
            this.requestCounter--;
        }, (error) => {
            this.requestCounter--;
            throw error;
        });
    }

    startAutoLogin(urls, token, maxWaitTimeout) {
        if (typeof (maxWaitTimeout) === 'undefined') {
            maxWaitTimeout = 180000;
        }
        for (let i = 0; i < urls.length; i++) {
            let url = urls[i];
            if (url !== null && url !== '') {
                this.startAutoLoginFor(url, token);
            }
        }
        this.waitTimeout = 0;
        return new Promise(resolve => {
            this.checkRequestCounter(resolve, maxWaitTimeout);
        });
    }

    static getSessionStatus() {
        return axios({
            method: 'GET',
            url: this.getUrl('/api/auth/v2/session-status')
        });
    }

    static resendVerification() {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/auth/v2/resend-verification')
        });
    }

    static submitSmsCode(code, type) {
        let data;
        if (type === 'guestSms') {
            data = { type, smsCode: code };
        } else {
            data = { type, code };
        }
        return axios({
            method: 'POST',
            url: this.getUrl('/api/auth/v2/activate'),
            data
        });
    }

    static submitSymantecVipCode(codes) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/auth/v2/activate'),
            data: {
                type: 'symantecVip',
                ...codes
            }
        });
    }

    static submitSigninVerification(oneTimePassword) {
        return axios({
            method: 'POST',
            url: this.getUrl('/api/auth/v2/activate'),
            data: {
                type: "signinVerification",
                action: "allow",
                deviceInfo: null,
                oneTimePassword: oneTimePassword
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/scripts/services/userAuth.js